/**
 * Branch/Location/Station context utility
 * Reads the location set during login (Step 2 of the login flow)
 */

export function getActiveBranchId(): string | null {
  return localStorage.getItem('activeBranchId') || localStorage.getItem('locationId') || null;
}

export function getActiveLocationName(): string | null {
  return localStorage.getItem('locationName') || null;
}

export function getActiveStationId(): string | null {
  return localStorage.getItem('stationId') || null;
}

export function getActiveStationName(): string | null {
  return localStorage.getItem('stationName') || null;
}

export function setActiveBranchId(id: string): void {
  localStorage.setItem('activeBranchId', id);
  window.dispatchEvent(new CustomEvent('branchChanged', { detail: id }));
}

/** Returns branch/station context object to include in any API create call */
export function getLocationContext(): { branchId?: string; stationId?: string; stationName?: string } {
  const branchId = getActiveBranchId();
  const stationId = getActiveStationId();
  const stationName = getActiveStationName();
  return {
    ...(branchId ? { branchId } : {}),
    ...(stationId ? { stationId } : {}),
    ...(stationName ? { stationName } : {}),
  };
}

/** Convenience: spread this into any create payload */
export function withBranch<T extends Record<string, any>>(data: T): T {
  return { ...data, ...getLocationContext() };
}
